export function PayrollTotalsBlock({ t }) {
  if (!t) return <div className="text-sm text-gray-500">No data.</div>;
  const fmt = (v, money = true) => money ? `$${Number(v || 0).toFixed(2)}` : Number(v || 0).toFixed(2);
  const rows = [
    ['Paychecks', t.employees, false],
    ['Regular hours', t.regular_hours, false],
    ['OT hours', t.overtime_hours, false],
    ['Holiday hours', t.holiday_hours, false],
    ['PTO hours', t.pto_hours, false],
    ['Total hours', t.total_hours, false],
    ['Regular pay', t.regular_pay, true],
    ['Overtime pay', t.overtime_pay, true],
    ['Holiday pay', t.holiday_pay, true],
    ['PTO pay', t.pto_pay, true],
    ['Tips', t.tips, true],
    ['Total wages', t.total_wages, true],
    ['Gross payroll', t.gross_payroll, true],
    ['Estimated employer taxes', t.employer_tax_estimate, true],
    ['Total cost', t.total_cost, true],
  ];
  return (
    <table style={{ width: '100%', fontSize: 13 }}>
      <tbody>
        {rows.map(([label, val, money]) => (
          <tr key={label} style={{ borderBottom: '1px solid #f0f0f0' }}>
            <td style={{ padding: 4 }}>{label}</td>
            <td style={{ padding: 4, textAlign: 'right' }}>{fmt(val, money)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
